import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import FormHelperText from '@material-ui/core/FormHelperText';
import React, { Fragment, useEffect, useCallback } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { DatePicker, DatePickerProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './form_date.scss';
import { toMoment } from '@core/utils/time';
import { R } from '@core/utils/r';

export interface FormRangePickerInputProps extends FieldProps<FormControl<number> | FormControl<number | null>> {
  onChange?(date: number | null): void;
  withoutGroup?: boolean;
  asterisk?: boolean;
  options?: Partial<DatePickerProps>;
  clearable?: boolean;
  showTime?: boolean;
  disabledDate?(current: Dayjs): boolean;
}

export function FormRangePickerInput(props: FormRangePickerInputProps) {
  const { disabledDate } = props;
  const { formControl, fieldState, fieldConfig } = useFormField(props);
  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = fieldState.value ? dayjs.unix(fieldState.value) : dayjs(new Date());
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const onChange = (value: DatePickerProps['value'], dateString: [string, string] | string) => {
    if (value) {
      formControl.setValue(value.unix());
      props.onChange && props.onChange(value.unix());
    } else {
      formControl.setValue(null);
      props.onChange && props.onChange(null);
    }
  };

  useEffect(() => {
    if (R.isNull(fieldState.value)) {
      formControl.setValue(toMoment().unix());
    }
  }, [fieldState.value, formControl]);

  const content = (
    <Fragment>
      {fieldConfig.label && (
        <Label for={formControl.uid}>
          {fieldConfig.label} {fieldConfig.required && props.asterisk && <span className="text-danger">*</span>}
        </Label>
      )}
      <DatePicker
        minuteStep={15}
        format={props.showTime ? 'MM/DD/YYYY hh:mma' : 'MM/DD/YYYY'}
        use12Hours
        changeOnBlur
        showTime={props.showTime || false}
        value={fieldValue}
        allowClear={props.clearable || false}
        {...props.options}
        popupStyle={{ zIndex: 9999 }}
        onChange={onChange}
        disabledDate={disabledDate}
      />
      {!!fieldError && <FormHelperText style={{ color: '#f44336' }}>{fieldError}</FormHelperText>}
    </Fragment>
  );

  if (props.withoutGroup) {
    return <div className="theme_date-picker d-flex flex-column">{content}</div>;
  }

  return <FormGroup className="theme_date-picker d-flex flex-column">{content}</FormGroup>;
}
